// FILE: src/components/legal/LegalFooter.js
//
// Small persistent footer with links to the public legal pages. The pages
// themselves are static HTML served at /privacy and /terms (stable URLs, work
// signed-out, independent of the SPA). Links open in a new tab.

import React from 'react';

const S = {
  footer: {
    marginTop: 'auto',
    padding: '18px 16px',
    textAlign: 'center',
    fontSize: '12px',
    color: '#6b7280',
    fontFamily: '-apple-system,Segoe UI,Roboto,Helvetica,Arial,sans-serif',
  },
  link: { color: '#6b7280', textDecoration: 'underline' },
  sep: { margin: '0 8px', color: '#c2c9d6' },
};

export default function LegalFooter() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="legal-footer" style={S.footer}>
      <a style={S.link} href="/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
      <span style={S.sep}>·</span>
      <a style={S.link} href="/terms" target="_blank" rel="noopener noreferrer">Terms of Service</a>
      <span style={S.sep}>·</span>
      <span>© {year} Campbellclan7 Consulting Inc. / PM Pixel</span>
    </footer>
  );
}
